import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { currentTopicSettings } from '../state/topicSettings';

/**
 * The rules, in the column beside the posts.
 *
 * Two lines:
 *
 * - how many topics one post may carry;
 * - which groups may use topic tags at all.
 *
 * The second line is only there when the forum restricts the feature. An
 * empty group list means everybody may use topics, and saying so would only
 * take up room.
 */
export default class TopicRules extends Component {
  view(vnode) {
    const settings = currentTopicSettings();

    // The feature is switched off: there is no rule to state.
    if (settings.maxPerPost <= 0) return null;
    const groups = settings.allowedGroups ?? [];
    return m("div", {
      className: "TopicRules"
    }, m("b", {
      className: "TopicRules-title"
    }, app.translator.trans('ziiven-topics.forum.rules.title')), m("div", {
      className: "TopicRules-body"
    }, m("div", null, app.translator.trans('ziiven-topics.forum.rules.max_per_post', {
      count: settings.maxPerPost
    })), groups.length ? m("div", null, app.translator.trans('ziiven-topics.forum.rules.groups_only', {
      groups: groups.join('、')
    })) : null));
  }
}
flarum.reg.add('ziiven-topics', 'forum/components/TopicRules', TopicRules);